import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrid3 } from '@fortawesome/pro-solid-svg-icons/faGrid3';
import { faGrid2 } from '@fortawesome/pro-solid-svg-icons/faGrid2';
import React from 'react';
import { useMailbox } from '../../../Providers/NewMailboxProvider';

function MailboxGridSize() {
	const { gridSize, SetGridSize } = useMailbox();

	return (
		<div className='flex-row flex-gap-sm align-center ml-a mr-md'>
			<FontAwesomeIcon icon={faGrid3} />
			<input
				type='range'
				min={0}
				max={2}
				defaultValue={gridSize.size}
				onChange={(e) => SetGridSize(parseInt(e.target.value, 10))}
			/>
			<FontAwesomeIcon icon={faGrid2} />
		</div>
	);
}

export { MailboxGridSize };
